var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container", staticStyle: { "margin-top": "90px" } },
      [
        _c("div", { staticClass: "jumbotron" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { disabled: !_setup.connectorIsReady },
                  on: { click: _setup.invokeTriggerPipelineManuallyCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-bolt",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Run pipeline")]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v("Run integration pipeline "),
            _c("strong", [_vm._v(_vm._s(_setup.pipelineName))]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
          }),
          _vm._v(" "),
          _setup.connectorStatus
            ? _c("p", [_vm._v("Status: " + _vm._s(_setup.connectorStatus))])
            : _vm._e(),
          _vm._v(" "),
          _setup.connectorProviderReadPageUrl
            ? _c("iframe", {
                ref: "connectorProviderReadPage",
                staticStyle: {
                  border: "none",
                  background: "none",
                  width: "100%",
                },
                attrs: {
                  name: "connectorProviderReadPage",
                  src: `${_setup.connectorProviderReadPageUrl}${_setup.tid}?pipelineId=${_setup.id}&connectorId=${_setup.connectorId}`,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-group" },
            _vm._l(_setup.runs, function (r) {
              return _c(
                "a",
                {
                  key: r.RunId,
                  staticClass: "list-group-item list-group-item-action",
                  class: {
                    "list-group-item-secondary": r.Queued,
                    "list-group-item-primary": r.Running,
                    "list-group-item-success": r.Succeed,
                    "list-group-item-danger":
                      (r.Failed || r.Aborted) && !r.Succeed,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex w-100 justify-content-between" },
                    [
                      _c("h6", { staticClass: "mb-1" }, [
                        r.Running
                          ? _c("span", [_vm._v("[Running]")])
                          : r.Succeed
                          ? _c("span", [_vm._v("[Succeed]")])
                          : r.Failed
                          ? _c("span", [
                              _vm._v(
                                "[Failed(" + _vm._s(r.FailuresCount) + ")]"
                              ),
                            ])
                          : r.Aborted
                          ? _c("span", [_vm._v("[Aborted]")])
                          : _c("span", [_vm._v("[Queued]")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(r.PipelineName) + "111")]),
                      ]),
                      _vm._v(" "),
                      _c("small", [
                        _c("span", [
                          _vm._v(_vm._s(r.LastActivityAtSinceNow) + " ago"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-1" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(r.Trigger) +
                        "\n                        "
                    ),
                    r.QueuedByName
                      ? _c("span", [_vm._v("by " + _vm._s(r.QueuedByName))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(r.QueuedAtSinceNow) + " ago")]),
                    _vm._v(" "),
                    r.StartedAtSinceNow
                      ? _c("span", [
                          _vm._v(
                            "/ started " + _vm._s(r.StartedAtSinceNow) + " ago"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    r.CompletedAtSinceNow
                      ? _c("span", [
                          _vm._v(
                            "/ completed " +
                              _vm._s(r.CompletedAtSinceNow) +
                              " ago"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    r.FailedAtSinceNow
                      ? _c("span", [
                          _vm._v(
                            "/ failed " + _vm._s(r.FailedAtSinceNow) + " ago"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    r.AbortedAtSinceNow
                      ? _c("span", [
                          _vm._v(
                            "/ aborted " + _vm._s(r.AbortedAtSinceNow) + " ago"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "nav",
      { staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark" },
      [
        _c(
          "button",
          {
            staticClass: "navbar-toggler",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#Navigation",
            },
          },
          [_c("span", { staticClass: "navbar-toggler-icon" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse navbar-collapse",
            attrs: { id: "Navigation" },
          },
          [
            _c("ul", { staticClass: "navbar-nav mr-auto" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "navbar-brand",
                    attrs: { href: "/#/organizations/users/dashboard" },
                  },
                  [_vm._v("Home")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-7" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
          },
        },
        [_vm._v("Integration Pipeline Trigger")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }